// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  eForceAPIURL: 'https://eforce-api.cap-tech.in',
  gatewayUrl: 'https://eforce-api.cap-tech.in',

  // Real-time chat Socket.IO URL
  // Leave empty ('') to use HTTP polling fallback.
  // Set to your Socket.IO server URL when backend is ready, e.g.:
  socketUrl: 'https://eforce-api.cap-tech.in',
  // socketUrl: '',
  // eForceAPIURL: 'https://eforce.cap-tech.in:4810',
  // eForceAPIURL: 'http://65.0.63.7:4807',
  // eForceAPIURL: 'https://eforce.cap-tech.in:4810',
  // eForceAPIURL: 'http://65.0.63.7:4804',

  excelWatermark: {
    enabled: true,
    maxCells: 200000
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
